import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const navItems = [
    { path: '/', label: 'Accueil' },
    { path: '/bureau', label: 'Bureau' },
    { path: '/activites', label: 'Activités' },
    { path: '/a-propos', label: 'À propos' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <nav className={`navigation ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <div className="nav-brand">
          <Link to="/" onClick={closeMobileMenu} className="brand-link">
            <div className="logo-container">
              <div className="logo-fallback">
                <span className="fallback-text">ASB</span>
              </div>
              <img
                src="/logo-asb.jpg"
                alt="Logo ASB"
                className="brand-logo"
                onLoad={(e) => {
                  // Cache le fallback si le logo se charge
                  e.target.previousElementSibling.style.display = 'none';
                  e.target.style.display = 'block';
                }}
                onError={(e) => {
                  // Affiche le fallback si le logo ne charge pas
                  e.target.style.display = 'none';
                  e.target.previousElementSibling.style.display = 'flex';
                }}
                style={{ display: 'none' }}
              />
            </div>
            <div className="brand-text-container">
              <span className="brand-text">ASB</span>
              <span className="brand-subtitle">BURKINA FASO • SÉNÉGAL</span>
            </div>
          </Link>
        </div>

        <div className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
          <ul>
            {navItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={location.pathname === item.path ? 'active' : ''}
                  onClick={closeMobileMenu}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <button
          className={`mobile-toggle ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default Header;